import {Grid} from "@material-ui/core";
import GridButtonRow from "../form-grids/GridButtonRow";
import DefaultButton from "./DefaultButton";

const SearchClearSaveRow = ({
    onClickSearch,
    onClickClear,
    onClickSave,
    onClickReset,
    onClickPrint,
    customGrid,
    disabledSearch,
    disabledClear,
    disabledSave,
    labelName,
    style,
    src,
    onDefaultClick,
    customButtons,
    customButtonsPosition = "end"
}) => (
    <>
        {customGrid ? (
            <>
                {onClickSearch !== undefined ? (
                    <Grid item xs={4} sm={3} md={2}>
                        <DefaultButton disabled={disabledSearch === 1 ? true: false} search className="primaryButton" onClick={onClickSearch} />
                    </Grid>
                ) : null}
                {onClickClear !== undefined ? (
                    <Grid item xs={4} sm={3} md={2}>
                        <DefaultButton disabled={disabledClear === 1 ? true : false} clear className="secondaryButton" onClick={onClickClear} />
                    </Grid>
                ) : null}
                {onClickSave !== undefined ? (
                    <Grid item xs={4} sm={3} md={2}>
                        <DefaultButton disabled={disabledSave === 1 ? true : false} save className="primaryButton" onClick={onClickSave} />
                    </Grid>
                ) : null}
                {onClickReset !== undefined ? (
                    <Grid item xs={4} sm={3} md={2}>
                        <DefaultButton reset className="primaryButton" onClick={onClickReset} />
                    </Grid>
                ) : null}
                {onClickPrint !== undefined ? (
                    <Grid item xs={4} sm={3} md={2}>
                        <DefaultButton print className="primaryButton" onClick={onClickPrint} />
                    </Grid>
                ) : null}
            </>
        ) : (
            <GridButtonRow>
                {(customButtons && customButtonsPosition === "start") && (
                    <>
                        {customButtons}
                    </>
                )}

                {onClickSearch !== undefined ? (
                    <Grid item xs={4} sm={3} md={2}>
                        <DefaultButton search className="primaryButton" onClick={onClickSearch} />
                    </Grid>
                ) : null}
                {onClickClear !== undefined ? (
                    <Grid item xs={4} sm={3} md={2}>
                        <DefaultButton clear className="secondaryButton" onClick={onClickClear} />
                    </Grid>
                ) : null}
                {onClickSave !== undefined ? (
                    <Grid item xs={4} sm={3} md={2}>
                        <DefaultButton save className="primaryButton" onClick={onClickSave} />
                    </Grid>
                ) : null}
                 {onDefaultClick !== undefined ? (
                    <Grid item xs={4} sm={3} md={2}>
                        <DefaultButton labelName={labelName} src={src} style={style} className="primaryButton" onClick={onDefaultClick} />
                    </Grid>
                ) : null}
                {(customButtons && customButtonsPosition === "end") && (
                    <>
                        {customButtons}
                    </>
                )}

            </GridButtonRow>
        )}
    </>
);
export default SearchClearSaveRow;
